import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CJGridComponent } from './components/cj-grid/cj-grid.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ModalLoaderComponent } from './components/modal-loader/modal-loader.component';
import { CommonModule } from '@angular/common';
import { ActionPasswordComponent } from './dialogs/action-password/action-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { CustomerLookupAgGridControlComponent } from './components/ag-grid-controls/customer-lookup-ag-grid-control/customer-lookup-ag-grid-control.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AddCustomerComponent } from './components/customers/add-customer/add-customer.component';
import { YesNoDialogComponent } from './dialogs/yes-no-dialog/yes-no-dialog.component';
import { YesNoRemarksDialogComponent } from './dialogs/yes-no-remarks-dialog/yes-no-remarks-dialog.component';
import { PaymentOptionComponent } from './components/payment/payment-option/payment-option.component';
import { ManualPaymentComponent } from './components/payment/manual-payment/manual-payment.component';
import { PaymentConfirmActionComponent } from './dialogs/payment-confirm-action/payment-confirm-action.component';
import { CashPaymentComponent } from './components/payment/cash-payment/cash-payment.component';
import { AchTcComponent } from './components/payment/ach-payment/ach-tc/ach-tc.component';
import { ACHPaymentComponent } from './components/payment/ach-payment/ach-payment.component';
import { CustomerAddressFormComponent } from './components/customers/customer-address-form/customer-address-form.component';
import { CardFormComponent } from './components/payment/card-form/card-form.component';
import { InvoiceNotesComponent } from './components/payment/card-form/invoice-notes/invoice-notes.component';
import { HeartlandCardTokenizerComponent } from './components/heartland-card-tokenizer/heartland-card-tokenizer.component';
import { CsvImportWizardComponent } from './components/csv-import/csv-import-wizard-component/csv-import-wizard-component';
import { CsvColumnMappingComponent } from './components/csv-import/csv-column-mapping/csv-column-mapping.component';
import { CsvImportValidationComponent } from './components/csv-import/csv-import-validation-component/csv-import-validation.component';
import { AgGridModule } from 'ag-grid-angular';
import { CsvImportResultsComponent } from './components/csv-import/csv-import-results-component/csv-import-results.component';
import { ItemLookupAgGridControlComponent } from './components/ag-grid-controls/item-lookup-ag-grid-control/item-lookup-ag-grid-control.component';
import { FrequencyFormComponent } from './components/frequency-form/frequency-form.component';
import { CustomerCardDataComponent } from './components/customers/customercarddata-form/customercarddata-form.component';
import { NotificationScheduleOptionsComponent } from './components/notification-schedule-options/notification-schedule-options.component';
import { SenderDialogComponent } from './dialogs/sender-dialog/sender-dialog.component';
import { FilterComponent } from './components/filter/filter.component';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { SignaturePadModule } from 'angular2-signaturepad';
import { AutofocusDirective } from './directives/autofocus.directive';
import { InputMaskModule } from '@ngneat/input-mask';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { InputCurrencyComponent } from './components/input-currency/input-currency.component';
import { SafePipe } from './pipes/safe.pipe';
import { ContactFormComponent } from './components/customers/contact-form/contact-form.component';
import { SearchComponent } from './components/customers/search/search.component';
import { AndroidMobileUrlComponent } from './components/android-mobile-url/android-mobile-url.component';
import { IosMobileUrlComponent } from './components/ios-mobile-url/ios-mobile-url.component';
import { GooglePayButtonComponent } from './components/google-pay-button/google-pay-button.component';
import { GooglePayButtonModule } from '@google-pay/button-angular';
import { GPayDisabledDirective } from './directives/g-pay-disabled.directive';
import { PaymentOptionsComponent } from './components/payment-options_revamp/payment-options.component';
import { ManualPayComponent } from './components/payment-options_revamp/manual-pay/manual-pay.component';
import { CashPayComponent } from './components/payment-options_revamp/cash-pay/cash-pay.component';
import { CardPayComponent } from './components/payment-options_revamp/card-pay/card-pay.component';
import { ACHPayComponent } from './components/payment-options_revamp/ach-pay/ach-pay.component';
import { AchPayTcComponent } from './components/payment-options_revamp/ach-pay/ach-pay-tc/ach-pay-tc.component';
import { PaymentTermsComponent } from './components/payment-options_revamp/payment-terms/payment-terms.component';
import { CjSvgIconComponent } from './components/cj-svg-icon/cj-svg-icon.component';

import {
  CjLayoutModule,
  CjSidebarModule,
  CjMenuModule,
  CjIconModule,
  CjTooltipModule,
  CjButtonModule,
  CjInputModule,
  CjFormFieldModule,
  CjCheckboxModule,
  CjRadioModule,
  CjTabsetModule,
} from '@cashjar-dev/ui';
import { CJTypeahead } from './components/cj-typeahead/cj-typeahead.component';
import { CJTagsComponent } from './components/cj-tags/cj-tags.component';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';
import { AmountToggleComponent } from './components/amount-toggle/amount-toggle.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { ForbiddemAccessComponent } from 'src/app/shared/components/forbiddem-access/forbiddem-access.component';
import { PermissionPipe } from './pipes/permission.pipe';
import { CardUpdateFormComponent } from './components/customers/card-update-form/card-update-form.component';
import { DigitsOnlyDirective } from './directives/digits-only.directive';

const CJ_COMPONENTS = [
  CjLayoutModule,
  CjSidebarModule,
  CjMenuModule,
  CjIconModule,
  CjTooltipModule,
  CjButtonModule,
  CjInputModule,
  CjFormFieldModule,
  CjCheckboxModule,
  CjRadioModule,
  CjTabsetModule,
];

const COMPONENT_REVAMPS = [
  PaymentOptionsComponent,
  ManualPayComponent,
  CashPayComponent,
  CardPayComponent,
  ACHPayComponent,
  AchPayTcComponent,
  CjSvgIconComponent,
  PaymentTermsComponent,
];

@NgModule({
  declarations: [
    CJGridComponent,
    LoaderComponent,
    ModalLoaderComponent,
    ActionPasswordComponent,
    SafeHtmlPipe,
    AddCustomerComponent,
    CustomerLookupAgGridControlComponent,
    YesNoDialogComponent,
    YesNoRemarksDialogComponent,
    PaymentOptionComponent,
    ManualPaymentComponent,
    PaymentConfirmActionComponent,
    CashPaymentComponent,
    AchTcComponent,
    ACHPaymentComponent,
    CustomerAddressFormComponent,
    CardFormComponent,
    InvoiceNotesComponent,
    HeartlandCardTokenizerComponent,
    CsvImportWizardComponent,
    CsvColumnMappingComponent,
    CsvImportValidationComponent,
    CsvImportResultsComponent,
    ItemLookupAgGridControlComponent,
    FrequencyFormComponent,
    SenderDialogComponent,
    CustomerCardDataComponent,
    NotificationScheduleOptionsComponent,
    FilterComponent,
    SlugifyPipe,
    AutofocusDirective,
    InputCurrencyComponent,
    SafePipe,
    ContactFormComponent,
    SearchComponent,
    AndroidMobileUrlComponent,
    IosMobileUrlComponent,
    GooglePayButtonComponent,
    GPayDisabledDirective,
    CJTypeahead,
    CJTagsComponent,
    ClickOutsideDirective,
    ...COMPONENT_REVAMPS,
    AmountToggleComponent,
    BreadcrumbComponent,
    ForbiddemAccessComponent,
    PermissionPipe,
    CardUpdateFormComponent,
    DigitsOnlyDirective,
  ],
  entryComponents: [ActionPasswordComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    AgGridModule,
    SignaturePadModule,
    InputMaskModule,
    NgxChartsModule,
    GooglePayButtonModule,
    // CashJar UI
    ...CJ_COMPONENTS,
    BreadcrumbModule,
  ],
  exports: [
    CJGridComponent,
    LoaderComponent,
    ModalLoaderComponent,
    SafeHtmlPipe,
    FrequencyFormComponent,
    NotificationScheduleOptionsComponent,
    FilterComponent,
    SlugifyPipe,
    AutofocusDirective,
    InputCurrencyComponent,
    SafePipe,
    InputMaskModule,
    NgxChartsModule,
    SearchComponent,
    AndroidMobileUrlComponent,
    IosMobileUrlComponent,
    GooglePayButtonComponent,
    GPayDisabledDirective,
    CJTypeahead,
    CJTagsComponent,
    ClickOutsideDirective,
    PaymentOptionComponent,
    AmountToggleComponent,
    // CashJar UI
    ...CJ_COMPONENTS,
    BreadcrumbComponent,
    ForbiddemAccessComponent,
    PermissionPipe,
    CjSvgIconComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
